"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zogno": {
    "803a2105": [{
      "hkey": "35902aee",
      "slug": "ambria-spino",
      "name": "Ambria-Spino",
      "primary": true,
      "skipSearch": false
    }],
    "ambria": [{
      "hkey": "35902aee",
      "slug": "ambria-spino",
      "name": "Ambria-Spino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9739ca2c": [{
      "hkey": "35902aee",
      "slug": "ambria-spino",
      "name": "Ambria-Spino",
      "primary": true,
      "skipSearch": false
    }],
    "spino-al-brembo": [{
      "hkey": "35902aee",
      "slug": "ambria-spino",
      "name": "Ambria-Spino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "zogno"
    }]
  }
};
exports["default"] = _default;